import { cloneDeep } from 'lodash';

import { ExtendedRoute } from '@ideapa/app-common';
import { createReducer, on } from '@ngrx/store';

import * as Actions from './navigation.actions';

export const NAVIGATION_FEATURE_KEY = 'navigation';

export interface NavigationPartialState {
  readonly [NAVIGATION_FEATURE_KEY]: NavigationState;
}

export interface NavigationState {
  routes: ExtendedRoute[];
}

const initialState: NavigationState = {
  routes: [],
};

export const reducer = createReducer(
  initialState,
  on(Actions.init, (state, { items }) => {
    return {
      ...state,
      routes: items,
    };
  }),
  on(Actions.showTab, (state, { path }) => {
    return {
      ...state,
      routes: setVisibility(state.routes, path, true),
    };
  }),
  on(Actions.closeTab, (state, { path }) => {
    return {
      ...state,
      routes: setVisibility(state.routes, path, false),
    };
  })
  // on(Actions.closeModuloRelatedTabs, (state) => {
  //   return {
  //     ...state,
  //     routes: closeModuloTabs(state.routes),
  //   };
  // }),
  // on(Actions.closeEnteAnnoRelatedTabs, (state) => {
  //   return {
  //     ...state,
  //     routes: closeEnteTabs(state.routes),
  //   };
  // })
);

const closeModuloTabs = (routes: ExtendedRoute[]) => {
  const tabsToClose = routes
    .filter((t) => t.tabOpened && t.modulo)
    .map((t) => t.path);
  return closeMultipleTabs(routes, tabsToClose);
};

const closeEnteTabs = (routes: ExtendedRoute[]) => {
  const tabsToClose = routes
    .filter((t) => t.tabOpened && t.ente)
    .map((t) => t.path);
  return closeMultipleTabs(routes, tabsToClose);
};

const setVisibility = (
  routes: ExtendedRoute[],
  path: string,
  visible: boolean
) => {
  let tabs = cloneDeep(routes);

  path = path.startsWith('/') ? path.substring(1) : path;
  const slashIndex = path.indexOf('/');
  if (slashIndex >= 0) {
    path = path.substring(0, slashIndex);
  }
  const tabIndex = tabs.findIndex(
    (t) => t.path.toLowerCase() === path.toLowerCase()
  );

  if (tabIndex >= 0) {
    if (tabs[tabIndex].tabOpened !== visible) {
      const positions: number[] = tabs
        .filter((t) => t.tabOpened)
        .map((t) => t.tabPosition || 0);

      if (positions.length) {
        tabs[tabIndex].tabPosition =
          !tabs[tabIndex].tabPosition && visible
            ? Math.max(...positions) + 1
            : undefined;
      } else {
        tabs[tabIndex].tabPosition = 1;
      }
    }
    tabs[tabIndex].tabOpened = visible;
  }

  if (visible) {
    tabs = tabs.map((t, i) =>
      i === tabIndex ? { ...t, tabActive: true } : { ...t, tabActive: false }
    );
  }
  return tabs;
};

const closeMultipleTabs = (routes: ExtendedRoute[], tabsToClose: string[]) => {
  let tabs = routes;
  for (let i = 0; i < tabsToClose.length; i++) {
    tabs = setVisibility(tabs, tabsToClose[i], false);
  }
  return tabs;
};
